import { useState } from "react";
import { listRetirements, setRetirement, type RetirementRecord } from "../services/retirements";

export default function RetirementsPanel({ onRestored }: { onRestored: () => void }) {
  const [records, setRecords] = useState<RetirementRecord[] | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const load = async () => {
    setBusy(true);
    try { setRecords(await listRetirements()); setError(null); }
    catch { setError("Archives indisponibles ; aucune restauration n’est confirmée."); }
    finally { setBusy(false); }
  };
  const restore = async (record: RetirementRecord) => {
    if (!window.confirm(`Restaurer « ${record.name} » sous la même identité ? Aucun démarrage automatique. Les anciens accès de services restent révoqués.`)) return;
    setBusy(true);
    try {
      await setRetirement(record.kind, record.id, false);
      setRecords(current => current?.filter(item => item.kind !== record.kind || item.id !== record.id) ?? null);
      setError(null);
      onRestored();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Restauration non confirmée. Actualisez avant de réessayer.");
    } finally { setBusy(false); }
  };
  return <section aria-label="Archives récupérables">
    <button className="contexts-button contexts-button-secondary" disabled={busy} onClick={() => void load()}>Archives récupérables / actualiser</button>
    <p>Archiver masque l’objet et interdit ses accès courants. Profils, coffre, clés et ressources sont conservés. Aucune capacité physique n’est libérée.</p>
    {error && <p role="alert">{error}</p>}
    {records?.length === 0 && <p>Aucune archive.</p>}
    {records?.map(record => <div key={`${record.kind}/${record.id}`}>
      <span>{record.kind === "context" ? "Contexte" : "Session"} — {record.name} — {record.registered_sessions} session(s) enregistrée(s), {record.retained_snapshot_bytes} octets de sauvegarde conservés</span>
      <button disabled={busy} onClick={() => void restore(record)}>Restaurer {record.name}</button>
    </div>)}
  </section>;
}
